import { Loader2, Trash2 } from "lucide-react";
import { MailModalOverlay } from "@/features/shared/MailModalOverlay";

type Props = {
  open: boolean;
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/** Confirmation stylisée — remplace window.confirm. */
export function MailConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  busy = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <MailModalOverlay open={open} onClose={onCancel} labelledBy="mail-confirm-title" variant="center">
      <div className="px-5 py-5">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600">
            <Trash2 className="h-5 w-5" aria-hidden />
          </span>
          <div className="min-w-0 pt-0.5">
            <h2 id="mail-confirm-title" className="text-base font-semibold text-[var(--mail-text)]">
              {title}
            </h2>
            {message ? (
              <p className="mt-1.5 text-sm leading-relaxed text-[var(--mail-muted)]">{message}</p>
            ) : null}
          </div>
        </div>

        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="rounded-full px-4 py-2.5 text-sm font-medium text-[var(--mail-muted)] transition hover:bg-[var(--mail-surface-hover)] disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-red-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-red-700 disabled:opacity-50"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            {confirmLabel}
          </button>
        </div>
      </div>
    </MailModalOverlay>
  );
}
